export const SETTINGS_REQUEST = 'SETTINGS_REQUEST';
export const SETTINGS_REQUEST_SUCCESS = 'SETTINGS_REQUEST_SUCCESS';
export const SETTINGS_REQUEST_FAILED = 'SETTINGS_REQUEST_FAILED';
